import { SsoConfigurationState } from '@pages/third-party-idp/store/states/sso-configuration.state';
import { UsersState } from '@pages/third-party-idp/store/states/users.state';
import { SsoEnforcementState } from '@pages/third-party-idp/store/states/sso-enforcement.state';
import { AutomaticUserCreationState } from '@pages/third-party-idp/store/states/automatic-user-creation.state';
import { MappingRulesState } from '@pages/third-party-idp/store/states/mapping-rules.state';
import { MappingRuleState } from '@pages/third-party-idp/store/states/mapping-rule.state';

export const thirdPartyIdpState = [
  SsoConfigurationState,
  SsoEnforcementState,
  UsersState,
  AutomaticUserCreationState,
  MappingRulesState,
  MappingRuleState,
];
